import { render, staticRenderFns } from "./GenderEquality.vue?vue&type=template&id=1c95efb1&scoped=true&"
import script from "./GenderEquality.vue?vue&type=script&lang=js&"
export * from "./GenderEquality.vue?vue&type=script&lang=js&"
import style0 from "./GenderEquality.vue?vue&type=style&index=0&id=1c95efb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c95efb1",
  null
  
)

export default component.exports